import { render, staticRenderFns } from "./right_1.vue?vue&type=template&id=4732457c&scoped=true&"
import script from "./right_1.vue?vue&type=script&lang=js&"
export * from "./right_1.vue?vue&type=script&lang=js&"
import style0 from "./right_1.vue?vue&type=style&index=0&id=4732457c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4732457c",
  null
  
)

export default component.exports